var _rect, _circle, _circle2, _line, _line2, _line3, _line4, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard10({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 334,
    viewBox: "0 0 388 334",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 334,
    rx: 24,
    fill: "#FBF4FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 193.749,
    cy: 166.749,
    r: 43.2485,
    stroke: "#735D7F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.007,
    cy: 166.749,
    r: 18.779,
    stroke: "#735D7F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 193.507,
    y1: 123,
    x2: 193.507,
    y2: 210.497,
    stroke: "#735D7F"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 166.249,
    x2: 237.497,
    y2: 166.249,
    stroke: "#735D7F"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 224.506,
    y1: 135.957,
    x2: 163.698,
    y2: 197.497,
    stroke: "#735D7F"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 163.701,
    y1: 136.735,
    x2: 223.762,
    y2: 196.796,
    stroke: "#735D7F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.636,
    cy: 167.119,
    r: 7.78576,
    fill: "#735D7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard10);
export default __webpack_public_path__ + "static/media/Card10.d4003388c87c2d74c042ef80fc4a9d44.svg";
export { ForwardRef as ReactComponent };